import { Caption, Text } from '@joor/design-system'
import styled from 'styled-components/macro'

export function Quantity({
  quantity,
  label,
  className = '',
  noTranslateCaption,
  wholesalePrice,
  quantityColor = 'primary-800',
}: Props) {
  return (
    <Holder className={className}>
      <Caption
        type="2"
        typeface="montserrat"
        color={'primary-400'}
        textAlign="right"
        className={noTranslateCaption ? 'notranslate' : ''}
      >
        {label}
      </Caption>
      <Text
        fontFamily="numeric"
        fontSize="small"
        fontWeight="semibold"
        lineHeight="16"
        letterSpacing="normal"
        margin={'0'}
        textAlign="right"
        className="notranslate"
        color={quantityColor}
      >
        {quantity}
      </Text>
      {wholesalePrice && (
        <Text
          fontFamily="numeric"
          fontSize="extrasmall"
          fontWeight="light"
          color="primary-500"
          lineHeight="14"
          letterSpacing="normal"
          margin={'0'}
          textAlign="right"
          className="notranslate"
        >
          {wholesalePrice}
        </Text>
      )}
    </Holder>
  )
}

type Props = {
  quantity: number | string
  label: string
  className?: string
  noTranslateCaption?: boolean
  wholesalePrice?: number | string
  quantityColor?: 'primary-800' | 'success-500'
}

const Holder = styled.div`
  p {
    margin: 0;
  }

  & p:first-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & p:last-child {
    margin-top: 4px;
  }
`
